import { Axios } from 'src/lib';

import { FronteggContext } from '@frontegg/rest-api';
import { quotaLoadingSlice, quotaSlice } from '../slices/quota.slice';
import { showToastError } from 'src/utilities/errortoast';

export const getQuotaAction = () => {
  return async (dispatch) => {
    dispatch(quotaLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await Axios.get(`/v2/quota`, { headers });
    const response = result?.data;
    try {
      if (result?.status === 200) {
        dispatch(quotaSlice(response));
      }
    } catch (error) {
      console.error('Error fetching quota:', error);
    } finally {
      dispatch(quotaLoadingSlice(false));
    }
  };
};
